import { Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { catchError, debounceTime, filter, map, of, Subject, Subscription, switchMap } from 'rxjs';
import { favourites, listAllarticle, listArticle } from 'src/interface/article';
import { GetArticlesService } from '../../../services/get-articles.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SharedService } from '../../../services/shared.service';
import { MainBodyService } from '../../../services/main-body.service';
import { themeData } from 'src/interface/themesetting';
import { EnvService } from '../../../services/env.service';
import { JournalService } from '../../journal.service';
import { TranslateService } from '@ngx-translate/core';
import { Meta, Title } from '@angular/platform-browser';
@Component({
    selector: 'app-article-listing',
    templateUrl: './article-listing.component.html',
    styleUrls: ['./article-listing.component.scss']
})
export class ArticleListingComponent implements OnInit, OnDestroy {
    // @ViewChild('keywords')
    // keywords!: ElementRef<HTMLDivElement>;
    @ViewChildren('authorDiv', { read: ElementRef }) myElements: QueryList<ElementRef>;
    // @ViewChildren('keywordSpan', { read: ElementRef }) spanElements: QueryList<ElementRef>;
    @ViewChild('alphHeading')
    divElements!: ElementRef<HTMLDivElement>;
    public articleList: listArticle[] = [];
    public abstract: boolean[] = [];
    // public keywordSearchForm: FormGroup;
    // public keySearchData: { keySearchValue: FormControl; };
    public searchData: string;
    public valueForSearch: string;
    searchedArticles: listArticle[] = [];
    search_filters: string[] = [];
    private searchSubject = new Subject<string>();
    private searchTerm: string | null = null;
    private readonly minSearchLength = 3;
    queryParams: listAllarticle;
    uncheck: boolean[] = [];
    isChevronUp: boolean[] = [true, true, true, true, true, true];
    isAngleDown: boolean[] = [];
    search_keywords: string[] = [];
    // allKeywords: string[] = [];
    keywordsByFirstLetter: string[] = [];
    objectKeywords: string[];
    showkeywords: boolean;
    sortCriteria: string;
    coverimage: string
    isCollapsed: boolean[] = [];
    temp_page_count: number;
    searchPipe: string;
    tempSearchArticles: listArticle[] = [];
    searching: boolean;
    totalPages: number;
    currentPage = 1;
    page_count = 0;
    dataToBeDisplay: number;
    startArticle: number;
    queryPara = {};
    journalId: string;
    issueurl: string;
    themeSettingsData: themeData;
    volume_id: string;
    issue_id: string;
    thematic_id = '';
    journal_id: string;
    articleCoverImageUrl: string;
    defaultArticleCoverImage: string;
    searchLoader: boolean;
    show_search_list: boolean;
    journalIdLoaded: boolean;
    enter_pressed: boolean;
    subscriptions: Subscription[] = [];
    activeTab: string;
    regularArticleList: listArticle[] = [];
    fasttrack: boolean;
    subject_area_filter = true;
    selectDiv = false;
    regularPagination = true;
    fasttrackNav = true;
    special_issue = false;
    breadcrumb = false;
    showTab: string;
    current_favourite: favourites[] = [];
    favourite_active = false;
    thematicOnly = false;
    supplementary = false;
    regularOnly = false;
    noNeededForJBA = false;
    loading = true;
    volumeIssue: boolean = false;
    showSearchCard = false;
    listOfIssues: any[] = [];
    shoWListOFIssues: boolean = false;
    routePageNo: string;
    articlesSub: Subscription;
    constructor(
        public mainBodyService: MainBodyService,
        private articleService: GetArticlesService,
        private router: Router,
        private route: ActivatedRoute,
        private sharedService: SharedService,
        private EnvService: EnvService,
        private journalService: JournalService,
        private translate: TranslateService, private titleService: Title,
        private metatag: Meta, @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.volume_id = '';
        this.issue_id = '';
        this.thematic_id = '';
        this.dataToBeDisplay = 10;
        this.startArticle = 0;
        // this.route.url.subscribe(segments => {
        //     if (segments.some(segment => segment.path === 'fasttrack')) {
        //         this.activeTab = 'fast-track-articles';
        //         this.fasttrack = true;
        //         // const ind = this.search_filters.findIndex(x => x === 'fasttrack');

        //         // if (ind == -1) {
        //         //     this.search_filters.push('fasttrack');
        //         // }
        //         // if (ind !== -1) {
        //         //     this.search_filters.splice(ind, 1);
        //         // }
        //         // this.getArticles();
        //     } else {
        //         this.activeTab = 'regular-articles'; // Default tab
        //     }
        // });

    }

    ngOnInit(): void {
        console.log(this.showSearchCard);
        this.routePageNo = this.route.snapshot.params['page_no'];

        const navSub = this.router.events
            .pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd)
            )
            .subscribe((event) => {
                // console.log(event);

                // const url = event.urlAfterRedirects;

                // console.log(url);

                // // ONLY match: /articles/page/<number>
                // const isArticlesPage = /^\/articles\/page\//.test(url);

                // this.showSearchCard = isArticlesPage;

                // The component is reused when only route params change (e.g. page/1 -> page/2),
                // so re-read them here to keep page state, API params and articles in sync.
                const params = this.route.snapshot.params;
                this.volume_id = params['volume_id'] ?? this.volume_id;
                this.issue_id = params['issue_id'] ?? this.issue_id;
                this.thematic_id = params['thematic_identifier'] ?? this.thematic_id;
                // Only apply page_no when it changed, so query-param-only navigations
                // (search/filters, which reset to page 1 themselves) are not overridden.
                if (params['page_no'] !== this.routePageNo) {
                    this.routePageNo = params['page_no'];
                    const page = parseInt(params['page_no'], 10);
                    this.currentPage = page > 0 ? page : 1;
                    this.startArticle = (this.currentPage - 1) * this.dataToBeDisplay;
                }
                this.loading = true;
                this.getArticles();
            });
        this.subscriptions.push(navSub);

        // this.activeTab = 'regular-articles';
        // const journalSub = this.sharedService.getJournalId().subscribe(journalId => {
        //     this.journalId = journalId;
        //     this.journal_id = journalId            
        // });
        // if (this.router.url.includes('page')) {
        //     this.breadcrumb = false;
        // }
        this.thematicOnly = this.route.snapshot.url.some(segment => segment.path === 'thematic-collections');
        this.supplementary = this.route.snapshot.url.some(segment => segment.path === 'supplementary-collections');
        this.regularOnly = this.route.snapshot.url.some(segment => segment.path === 'regular-articles');

        // if (this.thematicOnly) {
        //         const ind = this.search_filters.findIndex(x => x === 'thematic');
        //         if (ind == -1) {
        //             this.search_filters.push('thematic');
        //         }
        // }
        let currentUrl = this.router.url;
        console.log(currentUrl);
        const isArticlesPage = /^\/articles\/page\//.test(currentUrl);

        isArticlesPage == true ? this.showSearchCard = true : this.showSearchCard = false;
        console.log(this.showSearchCard);


        if (currentUrl.startsWith('/')) {
            currentUrl = currentUrl.substring(1);
        }

        this.metatag.updateTag(
            { property: 'og:url', content: this.EnvService.siteUrl + currentUrl },
        );
        const journalType = { jnl_type: "JNL" }
        if (this.journal_id == undefined) {

            const journaltype = this.journalService.getJournals(journalType).subscribe((result) => {
                this.breadcrumb = true;
                this.journal_id = result.data[0].id;
                this.journalId = result.data[0].id;
                // this.subscriptions.push(journalSub);
                this.metatag.updateTag(
                    { property: 'og:type', content: result.data[0].journal_type.type },
                );

                // this.metatag.updateTag(
                //     { property: 'og:image', content: this.EnvService.imageUrl + 'themes/' + result.data[0].journal_cover_image },
                // );
                const journal_id = this.route.snapshot.params['journal_id'];

                this.journalId = journal_id;
                if (this.journalId == undefined) {
                    this.selectDiv = true;
                    this.regularPagination = false;
                    this.fasttrackNav = false;
                }

                // this.issueurl = this.router.url;

                this.articleCoverImageUrl = this.EnvService.articleCoverImage + journal_id + '/';
                this.defaultArticleCoverImage = this.EnvService.defaultImagePath + this.EnvService.default_articleCoverImage;
                this.mainBodyService.urlchange(true)

                const routeSub = this.route.queryParams.subscribe(params => {
                    this.valueForSearch = params['search'] != undefined ? params['search'] : '';
                    this.searchPipe = this.valueForSearch;
                    this.search_filters = params['filters'] ? params['filters'].split(',') : [];
                    this.special_issue = params['special_issue'] === 'true' ? true : false;
                    // this.getArticles();
                });
                this.subscriptions.push(routeSub);

                // this.keywordSearchForm = new FormGroup({
                //     keySearchValue: new FormControl()
                // })
                // this.keySearchData = {
                //     keySearchValue: this.keywordSearchForm.get('keySearchValue') as FormControl
                // }
                if (this.search_filters.length > 0) {
                    this.search_filters.forEach(ele => {
                        this.uncheck[ele] = true;
                    })
                }
                // if( this.route.snapshot.params['page_no'] == undefined){
                //     this.router.navigate([this.router.url +  '/page/' + this.currentPage], { queryParams: this.queryPara });
                // }

                this.currentPage = this.route.snapshot.params['page_no'] != undefined ? parseInt(this.route.snapshot.params['page_no']) : this.currentPage;
                this.volume_id = this.route.snapshot.params['volume_id'] != undefined ? this.route.snapshot.params['volume_id'] : this.volume_id;
                this.issue_id = this.route.snapshot.params['issue_id'] != undefined ? this.route.snapshot.params['issue_id'] : this.issue_id;
                if (this.volume_id != '') {
                    this.showSearchCard = false;
                    const params = {
                        journal_id: this.journal_id,
                        volume: this.volume_id,
                        'type': this.supplementary ? 'supplementary' : ''
                    }
                    this.articleService.getVolumeIssue(params).subscribe((res) => {
                        this.shoWListOFIssues = true;
                        this.listOfIssues = res.data;
                        // res.data.forEach((element: any) => {
                        //     this.listOfIssues.push(element.issue);
                        // })

                        if (this.issue_id == '') {
                            this.issue_id = this.listOfIssues[0].issue;
                            this.getArticles();
                        }

                    });
                }
                else {
                    this.shoWListOFIssues = false;
                    // this.showSearchCard = true;
                }
                // console.log(this.issue_id);


                // if(this.issue_id!==''){
                //     this.shoWListOFIssues = true;
                //     this.listOfIssues.push(this.issue_id,'3','4');
                // }
                this.thematic_id = this.route.snapshot.params['thematic_identifier'] != undefined ? this.route.snapshot.params['thematic_identifier'] : this.thematic_id;
                // this.journal_id = this.route.snapshot.params['journal_id'] != undefined ? this.route.snapshot.params['journal_id'] : 'All';
                if (this.volume_id > '11') {
                    const image = this.EnvService.default_article_cover_image_above_11;
                    this.metatag.updateTag(
                        { property: 'og:image', content: image },
                    );

                }
                else {
                    const image = this.EnvService.default_article_cover_image_upto_11;
                    this.metatag.updateTag(
                        { property: 'og:image', content: image },
                    );
                }


                this.startArticle = this.currentPage == 1 ? 0 : (this.currentPage - 1) * this.dataToBeDisplay;
                // if (this.router.url.includes('fasttrack')) {
                //     this.activeTab = 'fast-track-articles';
                //     this.fasttrack = true;
                //     const ind = this.search_filters.findIndex(x => x === 'fasttrack');
                //     if (ind == -1) {
                //         this.search_filters.push('fasttrack');
                //     }
                //     this.getArticles();
                // }
                // else {
                //     const ind = this.search_filters.findIndex(x => x === 'fasttrack');
                //     if (ind !== -1) {
                //         this.search_filters.splice(ind, 1);
                //     }
                //     this.activeTab = 'regular-articles'; // Default tab
                //     this.getArticles();
                // }
                if (this.router.url.includes('current-articles')) {
                    this.activeTab = 'current-articles';
                    this.showTab = 'current-articles';
                    // this.fasttrack = true;
                    // const ind = this.search_filters.findIndex(x => x === 'fasttrack');
                    // if (ind == -1) {
                    //     this.search_filters.push('fasttrack');
                    // }
                    this.getArticles();
                }
                else if (this.router.url.includes('thematic-collections')) {
                    const ind = this.search_filters.findIndex(x => x === 'thematic');
                    if (ind == -1) {
                        this.search_filters.push('thematic');
                    }
                    this.getArticles();
                }
                else if (this.router.url.includes('regular-article')) {
                    const ind = this.search_filters.findIndex(x => x === 'regular');
                    if (ind == -1) {
                        this.search_filters.push('regular');
                    }
                    this.getArticles();
                }
                else {
                    if (this.volume_id || this.issue_id) {
                        this.activeTab = 'current-issue';
                        this.showTab = 'current-issue';
                        this.getArticles();
                    }
                    else {
                        // this.activeTab = 'all-articles';
                        // this.showTab = 'all-articles';
                        // const ind = this.search_filters.findIndex(x => x === 'fasttrack');
                        // if (ind == -1) {
                        //     this.search_filters.splice(ind, 1);
                        // }
                        this.volumeIssue = true;
                        this.getArticles();
                    }
                }
                if (this.special_issue === false) {
                    this.translate.get('article_listing.current_articles_jba').subscribe((translation: string) => {
                        const page_heading = translation;

                        this.titleService.setTitle('All-Articles' + ' | ' + page_heading + ' | ' + 'Journal of British Academy')
                        this.metatag.updateTag(
                            { property: 'og:title', content: page_heading },
                        );
                    });
                }
                else if (this.showTab === 'all-articles') {
                    this.translate.get('article_listing.special_issues_jba').subscribe((translation: string) => {
                        const page_heading = translation;

                        this.titleService.setTitle('All-Articles' + ' | ' + page_heading + ' | ' + 'Journal of British Academy')
                        this.metatag.updateTag(
                            { property: 'og:title', content: page_heading },
                        );
                    });
                }
                // Every input change (typing, backspace, clearing) goes through here. Short/empty
                // terms still pass through switchMap so any in-flight request is cancelled, and each
                // response carries the term it was requested for, so stale results are dropped.
                const searchSub = this.searchSubject.pipe(
                    debounceTime(300),
                    switchMap((term: string) => term.length < this.minSearchLength
                        ? of({ term, result: null, skipped: true })
                        : this.articleService.searchArticle(this.buildSuggestionParams(term), this.journal_id).pipe(
                            map(result => ({ term, result, skipped: false })),
                            catchError(() => of({ term, result: null, skipped: false }))
                        )
                    )
                ).subscribe(({ term, result, skipped }) => {
                    if (skipped || term !== this.searchTerm) {
                        return;
                    }
                    this.searchLoader = false;
                    if (!result) {
                        // Request failed: don't claim there are no matching articles.
                        this.show_search_list = false;
                        return;
                    }
                    this.searchedArticles = result.data ?? [];
                    this.temp_page_count = result.total_count;
                    this.tempSearchArticles = this.searchedArticles;
                    this.show_search_list = true;
                })
                this.subscriptions.push(searchSub);
                this.searchPipe = this.valueForSearch;

                //setting queryParams in pagination
                if (this.valueForSearch) {
                    this.queryPara['search'] = this.valueForSearch;
                }
                // if (this.search_filters.length > 0) {
                //     if (this.search_filters.includes('thematic')) {
                //         this.search_filters = this.search_filters.filter(item => item !== 'thematic');
                //     }
                //     if(this.search_filters.length > 0){
                //         this.queryPara['filters'] = this.search_filters.toString();
                //     }
                //     console.log(this.search_filters);

                // }
                if (this.journal_id) {
                    const themeSub = this.mainBodyService.getAllThemeSettings(this.journal_id).subscribe((result) => {
                        if (result.data) {
                            this.themeSettingsData = result.data;
                            const color = this.themeSettingsData.theme_colors;
                            if (isPlatformBrowser(this.platformId)) {
                                Object.entries(color).map(([key, value]) => {
                                    const element = "--" + key;
                                    const val = value;
                                    document.documentElement.style.setProperty(element, val);
                                });
                            }
                        }
                    });
                    this.subscriptions.push(themeSub);
                }
            });
            this.subscriptions.push(journaltype);


        }


        const translation = this.translate.get('article_listing.current_articles_jba').subscribe((translation: string) => {
            const page_heading = translation;
            this.titleService.setTitle(page_heading + ' | ' + 'Journal of British Academy')

        });
        this.subscriptions.push(translation);

        const url = this.route.params.subscribe(params => {
            this.sharedService.setUrlParams(params);
        });
        this.subscriptions.push(url);
    }
    @HostListener('document:keydown.enter', ['$event']) onKeydownHandler() { //event: KeyboardEvent
        this.showSearchedArticle(true);
        this.enter_pressed = true;
    }

    @HostListener('document:keyup', ['$event'])
    onKeyUp(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.enter_pressed = false;
        }
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside() { //event: MouseEvent
        this.show_search_list = false;
    }

    checkBoxChange(event: string[]) {
        this.search_filters = event;
        // this.queryPara = {};
        if (this.search_filters.length > 0) {
            if (this.search_filters.includes('thematic')) {
                this.search_filters = this.search_filters.filter(item => item !== 'thematic');
            }
            if (this.search_filters.length > 0) {
                this.queryPara['filters'] = this.search_filters.toString();
            }

        }
        if (this.valueForSearch !== '') {
            this.queryPara['search'] = this.valueForSearch;
        }
    }

    clearAllCheckbox(cleared: boolean) {
        if (cleared) {
            this.queryPara['filters'] = '';

            this.router.navigate([], {
                // relativeTo: true, // Optional if you want to navigate relative to the current route
                queryParams: {},
                queryParamsHandling: 'merge', // Merge with new query parameters if needed
                preserveFragment: true, // Preserve the fragment part of the URL
            });
            // Now, add the new query parameters
            this.router.navigate([], {
                // relativeTo: this.activatedRoute, // Optional if you want to navigate relative to the current route
                queryParams: this.queryPara,
                queryParamsHandling: 'merge', // Merge with existing query parameters, do not add extra ones
                preserveFragment: true, // Preserve the fragment part of the URL
            });
        }
    }

    showSearchedArticle(isClicked: boolean) {
        this.cancelSuggestions();
        this.searchLoader = !isClicked;
        this.searchPipe = this.valueForSearch;

        if (this.valueForSearch) {
            this.queryPara['search'] = this.valueForSearch;
        }
        // if (this.search_filters.length > 0) {
        //     if (this.search_filters.includes('thematic')) {
        //         this.search_filters = this.search_filters.filter(item => item !== 'thematic');
        //     }
        //     if(this.search_filters.length > 0){
        //         this.queryPara['filters'] = this.search_filters.toString();
        //     }   
        // }
        this.currentPage = 1;
        this.startArticle = this.currentPage === 1 ? 0 : (this.currentPage - 1) * this.dataToBeDisplay;
        const queryParams: listAllarticle = {
            length: this.dataToBeDisplay,
            start: this.startArticle,
            search_key: this.valueForSearch,
            search_filters: this.search_filters.toString(),
            search_keywords: '',
            sort_by: '',
            volume_id: this.volume_id,
            issue_id: this.issue_id,
            special_issue: this.special_issue,
            thematic_id: this.thematic_id
            // favourites_data:this.current_favourite,
            // journal_id:this.journal_id
        }
        const getAllArticleSub = this.articleService.getArticles(queryParams, this.journal_id).subscribe(result => {
            this.articleList = result.data;
            if (this.articleList) this.loading = false;
            this.page_count = result.total_count;
            this.totalPages = Math.ceil(this.page_count / this.dataToBeDisplay);
            this.isCollapsed.fill(true, 0, this.articleList.length - 1);
        })

        this.router.navigate([], {
            // relativeTo: true, // Optional if you want to navigate relative to the current route
            queryParams: {},
            queryParamsHandling: 'merge', // Merge with new query parameters if needed
            preserveFragment: true, // Preserve the fragment part of the URL
        });

        // Now, add the new query parameters
        this.router.navigate([], {
            // relativeTo: this.activatedRoute, // Optional if you want to navigate relative to the current route
            queryParams: this.queryPara,
            queryParamsHandling: 'merge', // Merge with existing query parameters, do not add extra ones
            preserveFragment: true, // Preserve the fragment part of the URL
        });
        this.subscriptions.push(getAllArticleSub);
    }

    clearSearch(isClick: boolean) {
        // this.volume_id = '';
        // this.issue_id = '';
        if (isClick) {
            this.searchedArticles = [];
        }
        this.cancelSuggestions();
        this.searchPipe = '';
        this.valueForSearch = '';
        this.special_issue = false;
        const queryParams: listAllarticle = {
            length: this.dataToBeDisplay,
            start: 0,
            search_key: '',
            search_filters: this.thematicOnly ? 'thematic' : '' || this.regularOnly ? 'regular' : '',
            search_keywords: '',
            sort_by: '',
            volume_id: this.volume_id,
            issue_id: this.issue_id,
            special_issue: this.special_issue,
            thematic_id: this.thematic_id
            // favourites_data:this.current_favourite,
            // journal_id:this.journal_id
        }
        const getAllArticleSub = this.articleService.getArticles(queryParams, this.journal_id).subscribe(result => {
            this.articleList = result.data;
            if (this.articleList) this.loading = false;
            this.page_count = result.total_count;
            this.totalPages = Math.ceil(this.page_count / this.dataToBeDisplay);
        })
        this.subscriptions.push(getAllArticleSub);
        this.queryPara = {};
        // if (this.valueForSearch !== '') {
        this.queryPara['search'] = this.valueForSearch;
        this.queryPara['special_issue'] = this.special_issue;
        // }
        if (this.search_filters.length > 0) {
            if (this.search_filters.includes('thematic')) {
                this.search_filters = this.search_filters.filter(item => item !== 'thematic');
            }
            if (this.search_filters.length > 0) {
                this.queryPara['filters'] = this.search_filters.toString();
            }

        }
        this.show_search_list = false;
        this.router.navigate([], {
            // relativeTo: true, // Optional if you want to navigate relative to the current route
            queryParams: {},
            queryParamsHandling: 'merge', // Merge with new query parameters if needed
            preserveFragment: true, // Preserve the fragment part of the URL
        });
        // Now, add the new query parameters
        this.router.navigate([], {
            // relativeTo: this.activatedRoute, // Optional if you want to navigate relative to the current route
            queryParams: this.queryPara,
            queryParamsHandling: 'merge', // Merge with existing query parameters, do not add extra ones
            preserveFragment: true, // Preserve the fragment part of the URL
        });
    }

    showKeywordDiv(keyword_show: boolean) {
        this.showkeywords = keyword_show;
        // const queryParams: keywordList = { length: 0, start: 0 }
        // const keywordsSub = this.articleService.getKeywords(queryParams, this.journal_id).subscribe(result => {
        //     this.allKeywords = result.keywords;
        //     this.alphabetsAndKeywords(this.allKeywords);
        // })
        // this.subscriptions.push(keywordsSub);
    }

    // alphabetsAndKeywords(keywords: string[]) {
    //     this.keywordsByFirstLetter = keywords.reduce((alph, words) => {
    //         const firstLetter = words[0].toUpperCase();
    //         if (!alph[firstLetter]) {
    //             alph[firstLetter] = [words];
    //         } else {
    //             alph[firstLetter].push(words);
    //         }
    //         return alph;
    //     }, []);

    //     this.objectKeywords = Object.keys(this.keywordsByFirstLetter);
    //     this.objectKeywords.sort();
    // }

    clickOnEachKeywords(words: string) {
        const ind = this.search_keywords.findIndex(x => x == words);
        if (ind === -1) {
            this.search_keywords.push(words);
        }
        else {
            this.search_keywords.splice(ind, 1);
        }
        const keywrds = this.search_keywords.length == 0 ? '' : this.search_keywords.toString();
        this.queryParams = {
            start: 0,
            length: this.dataToBeDisplay,
            search_filters: '',
            search_key: '',
            search_keywords: keywrds,
            sort_by: '',
            volume_id: this.volume_id,
            issue_id: this.issue_id,
            special_issue: this.special_issue,
            thematic_id: this.thematic_id
            // favourites_data:this.current_favourite,
            // journal_id:this.journal_id
        }

        const getAllArticleSub = this.articleService.getArticles(this.queryParams, this.journal_id).subscribe(result => {
            this.articleList = result.data;
            if (this.articleList) this.loading = false;
            this.page_count = result.total_count;
            this.totalPages = Math.ceil(this.page_count / this.dataToBeDisplay);
        })
        this.subscriptions.push(getAllArticleSub);
    }

    // focusToAlphabets(alph: string) {
    //     const alphKeywords = this.keywords.nativeElement.children;
    //     for (let i = 0; i < alphKeywords.length; i++) {
    //         if (alphKeywords[i].children[0].textContent == alph) {
    //             alphKeywords[i].scrollIntoView({
    //                 block: 'center'
    //             });
    //             alphKeywords[i].children[0].classList.add('highlight');
    //             setTimeout(() => {
    //                 alphKeywords[i].children[0].classList.remove('highlight');
    //             }, 1000);
    //         }
    //     }
    // }

    // focustoKeyword() {
    //     const spanCount = this.spanElements.toArray().length;
    //     const keyword = this.keywordSearchForm.get('keySearchValue')?.value;
    //     const regex = new RegExp(keyword, 'gi');
    //     for (let i = 0; i < spanCount; i++) {
    //         const id = this.spanElements.toArray()[i].nativeElement.getAttribute('id');
    //         this.spanElements.toArray()[i].nativeElement.innerHTML = id;
    //         if (keyword.length > 0) {
    //             const data = this.spanElements.toArray()[i].nativeElement.innerHTML.match(regex);
    //             if (data !== null) {
    //                 const highlightedTerm = `<span style="color:red;background-color:yellow">` + data[0] + `</span>`;
    //                 const content = this.spanElements.toArray()[i].nativeElement.innerHTML.replace(regex, highlightedTerm);
    //                 this.spanElements.toArray()[i].nativeElement.innerHTML = content;
    //             }
    //         }
    //     }
    // }

    toggleSort(sortField: string) {
        this.sortCriteria = sortField;
        const keywrds = this.search_keywords.length == 0 ? '' : this.search_keywords.toString();
        const searchFilters = this.search_filters.length == 0 ? '' : this.search_filters.toString();
        this.queryParams = {
            length: this.dataToBeDisplay,
            start: 0,
            search_filters: searchFilters,
            search_key: this.valueForSearch,
            search_keywords: keywrds,
            sort_by: this.sortCriteria,
            volume_id: this.volume_id,
            issue_id: this.issue_id,
            special_issue: this.special_issue,
            thematic_id: this.thematic_id
            // favourites_data:this.current_favourite,
            // journal_id:this.journal_id
        }
        const getAllArticleSub = this.articleService.getArticles(this.queryParams, this.journal_id).subscribe(result => {
            this.articleList = result.data;
            if (this.articleList) this.loading = false;
            this.page_count = result.total_count;
            this.totalPages = Math.ceil(this.page_count / this.dataToBeDisplay);
        })
        this.subscriptions.push(getAllArticleSub);
    }

    // prevPage() {
    //     if (this.currentPage > 1) {
    //         this.currentPage--;
    //         this.changePage(this.currentPage);
    //     }
    // }

    // nextPage() {
    //     if (this.currentPage < this.totalPages) {
    //         this.currentPage++;
    //         this.changePage(this.currentPage);
    //     }
    // }

    changeLoading(loading: boolean) {
        this.loading = loading;
    }

    searchEmitFunction(searchData: string) {
        if (this.enter_pressed === true) {
            this.cancelSuggestions();
            return;
        }
        this.valueForSearch = searchData ?? '';
        const term = this.valueForSearch.trim();
        // Keys that don't change the value (arrows, shift, ...) must not reset the suggestions.
        if (term === this.searchTerm) {
            return;
        }
        this.searchTerm = term;
        // Drop results of the previous term; "No article found" is only shown once the API
        // has answered for this exact term.
        this.searchedArticles = [];
        this.show_search_list = false;
        this.searchLoader = term.length >= this.minSearchLength;
        this.queryParams = {
            length: this.dataToBeDisplay,
            start: this.startArticle,
            search_key: this.valueForSearch,
            search_filters: this.search_filters.toString(),
            search_keywords: '',
            sort_by: '',
            volume_id: this.volume_id,
            issue_id: this.issue_id,
            special_issue: this.special_issue,
            thematic_id: this.thematic_id
            // favourites_data:this.current_favourite,
            // journal_id:this.journal_id
        }
        if (this.valueForSearch.length === 0) {
            this.searchPipe = '';
            this.searchLoader = false;
            this.show_search_list = false;
            this.queryParams = {
                length: this.dataToBeDisplay,
                start: this.startArticle,
                search_key: this.valueForSearch,
                search_filters: this.search_filters.toString(),
                search_keywords: '',
                sort_by: '',
                volume_id: this.volume_id,
                issue_id: this.issue_id,
                special_issue: this.special_issue,
                thematic_id: this.thematic_id
                // favourites_data:this.current_favourite,
                // journal_id:this.journal_id
            }
        }
        this.searchSubject.next(term);
    }

    buildSuggestionParams(term: string): listAllarticle {
        return {
            length: this.dataToBeDisplay,
            start: 0,
            search_key: term,
            search_filters: this.search_filters.toString(),
            search_keywords: '',
            sort_by: '',
            volume_id: this.volume_id,
            issue_id: this.issue_id,
            special_issue: this.special_issue,
            thematic_id: this.thematic_id
        };
    }

    // Hides the suggestion dropdown and makes any pending/in-flight response be ignored.
    cancelSuggestions() {
        this.searchTerm = null;
        this.searchLoader = false;
        this.show_search_list = false;
    }
    switchTab(tabId: string) {
        this.activeTab = tabId;
        const ind = this.search_filters.findIndex(x => x === 'fasttrack');
        if (this.activeTab === 'current-articles') {

            if (ind == -1) {
                this.search_filters.push('fasttrack');
            }
            this.current_favourite = [];
            this.getArticles();
            this.router.navigate(['/current-articles/page/' + this.currentPage]);
        }
        if (isPlatformBrowser(this.platformId)) {
            if (this.activeTab === 'favourite-articles') {
                const favourite_data = localStorage.getItem('favourites');
                this.current_favourite = favourite_data
                    ? JSON.parse(favourite_data)
                    : this.current_favourite;
                this.getArticles();
            }
        }
        if (this.activeTab === 'all-articles') {
            const ind = this.search_filters.findIndex(x => x === 'fasttrack');
            if (ind !== -1) {
                this.search_filters.splice(ind, 1);
            }
            this.current_favourite = [];
            this.getArticles();
        }
        if (this.activeTab === 'current-issue') {
            this.current_favourite = [];
            this.getArticles();
        }
    }

    journalEmit(journal: string) {
        this.journal_id = journal;
    }

    getArticles() {
        this.articleList = [];

        const queryParams: listAllarticle = {
            length: this.dataToBeDisplay,
            start: this.startArticle,
            search_key: this.valueForSearch,
            search_filters: this.search_filters.toString(),
            search_keywords: '',
            sort_by: '',
            volume_id: this.volume_id,
            issue_id: this.issue_id,
            special_issue: this.special_issue,
            thematic_id: this.thematic_id
            // favourites_data:this.current_favourite,
            // journal_id:this.journal_id
        }

        // const query={
        //     volume:this.volume_id,
        //     issue:this.issue_id,
        //     journal_id:this.journal_id
        // }

        // const thematic_collection = this.articleService.getThematic(query).subscribe(result=>{

        // })
        // this.subscriptions.push(thematic_collection);
        // Drop any in-flight request so a stale page can't overwrite the current one.
        this.articlesSub?.unsubscribe();
        const getAllArticleSubVal = this.articlesSub = this.articleService.getArticles(queryParams, this.journal_id).subscribe(result => {
            // Set the article list with the sorted data
            // this.articleList = result.data.sort((a, b) => {
            //     if (a.article_type === "editors-introduction" && b.article_type !== "editors-introduction") {
            //         return -1;
            //     }
            //     if (a.article_type !== "editors-introduction" && b.article_type === "editors-introduction") {
            //         return 1;
            //     }
            //     return 0;
            // });

            this.articleList = result.data.sort((a, b) => {
                if (a.subject_heading === "Editors’ Introduction" && b.article_type !== "Editors’ Introduction") {
                    return -1;
                }
                if (a.subject_heading !== "eEditors’ Introduction" && b.article_type === "Editors’ Introduction") {
                    return 1;
                }

                return 0;
            });
            if (this.articleList) this.loading = false;
            this.page_count = result.total_count;
            this.totalPages = Math.ceil(this.page_count / this.dataToBeDisplay);
            this.isCollapsed.fill(true, 0, this.articleList.length);  // Updated to include the full length


        });

        this.subscriptions.push(getAllArticleSubVal);
    }

    emitedVolume(volume: string) {
        this.volume_id = volume;
    }
    emitedIssue(issue: string) {
        this.issue_id = issue;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
        this.destroyMetaTagsforSEONew();
    }
    specialIssueChange(checked: boolean) {
        this.special_issue = checked;
        this.queryParams = {
            start: 0,
            length: this.dataToBeDisplay,
            search_filters: '',
            search_key: '',
            search_keywords: '',
            sort_by: '',
            volume_id: this.volume_id,
            issue_id: this.issue_id,
            special_issue: this.special_issue,
            thematic_id: this.thematic_id
            // favourites_data:this.current_favourite,
            // journal_id:this.journal_id
        }
        this.getArticles();
    }
    changeIssue(issue: any) {
        // Regular expression pattern to match 'and'
        const pattern = /and/;
        let outputString: string = 'Issue ' + issue;
        if (issue.match(pattern)) {
            // Replace 'and' with '/'
            outputString = 'Issue ' + issue.replace(pattern, ' & ');
        }

        // Regular expression pattern to match 's' followed by a number
        const nextpattern = /s(\d+)/;

        if (issue.match(nextpattern)) {
            const issue_num = issue.match(nextpattern)[1];
            // Replace 's' followed by a number with 'supplementary issue' followed by that number
            outputString = issue.replace(nextpattern, 'Supplementary issue ' + issue_num);
        }

        if (issue == 'non-issue') {
            outputString = 'Regular articles';
        }

        return outputString;
    }

    goToPage(url: string) {
        this.router.navigate([url])
    }
    public destroyMetaTagsforSEONew() {
        this.metatag.updateTag(
            { property: 'og:url', content: this.EnvService.siteUrl },
        );
        this.metatag.updateTag(
            { property: 'og:title', content: "Journal of the British Academy" },
        );
        this.metatag.updateTag(
            { property: 'og:description', content: "Journal of the British Academy" },
        );
        // this.metatag.updateTag(
        //     { property: 'og:image', content: this.EnvService.imageUrl + "themes/default_logo.png" },
        // );

    }
}
